import { makeStyles } from '@mui/styles';
import PreviewModeConstants from '../../constants/PreviewModeConstants';
// Hardcoded values - the same colors and fonts are used in every market, they cannot be overridden in theme files.
const previewModeBannerStyles = makeStyles(() => ({
    container: {
        position: 'sticky',
        top: 0,
        zIndex: 110,
        backgroundColor: '#f1c40e',
        textAlign: 'center',
        height: PreviewModeConstants.bannerHeight,
    },
    title: {
        color: '#07446a',
        // TODO fix guidance linting error forbidden-style-keys
        // eslint-disable-next-line @dxp-module/guidance/forbidden-style-keys
        fontFamily: 'system-ui,-apple-system, sans-serif',
        fontWeight: 'bold',
        lineHeight: PreviewModeConstants.bannerHeight,
    },
}));
export default previewModeBannerStyles;
//# sourceMappingURL=previewModeBanner.styles.js.map